<script setup lang="ts">
/**
 * Invisible loading screen - just background color for seamless transition.
 * Shows while waiting for /process_start API call to complete.
 */
</script>

<template>
  <div class="h-screen w-screen bg-background" />
</template>
